import { render, staticRenderFns } from "./SolidGeometryViz.vue?vue&type=template&id=13c0763c&scoped=true"
import script from "./SolidGeometryViz.vue?vue&type=script&lang=js"
export * from "./SolidGeometryViz.vue?vue&type=script&lang=js"
import style0 from "./SolidGeometryViz.vue?vue&type=style&index=0&id=13c0763c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c0763c",
  null
  
)

export default component.exports